import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const pointer: SxStyle = {
  cursor: 'pointer',
};
